<template>
  <div>
    <b-modal
      id="NewsModal"
      ref="dashboardNews"
      v-model="showModal"
      size="lg"
      centered
      body-class="d-flex fixed-height align-items-center pb-5 pt-0 px-3 px-lg-5"
      content-class="px-3"
      title-tag="span"
      hide-footer
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :hide-header-close="true"
    >
    <b-col>
    <b-row class="text-center">
      <h5 class="col-12 text-primary font-weight-bold pb-2">Welcome to FOResT!</h5>
      <h5 class="col-12 text-primary font-weight-bold pb-2">We've made some updates to the Dashboard.</h5>
    </b-row>
    <div>
      <b>Notifications</b><br/>
        Your notifications are now consolidated into a single table. Use the tabs below "My Notifications" to toggle between notifications to view them by statuses.
      <b-img src="https://timmons-branding.s3.amazonaws.com/MFS-FOResT/noti_cs.png" fluid ></b-img>
      <b>Landowner Reports</b><br/>
        Your landowner reports are now available to view on the dashboard. Like notifications, you can use the tabs to toggle between statuses.
      <b-img src="https://timmons-branding.s3.amazonaws.com/MFS-FOResT/lor_cs.png" fluid ></b-img><br/><br/>
      <div class="btn-wrapper">
        <b-button
          id="continue_btn"
          router-tag="button"
          variant="secondary"
          pill
          @click="closeModal()"
          aria-label="Continue to dashboard"
        >
          Continue
        </b-button>
      </div>
    </div>
    </b-col>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'NewsModal',
  components: {
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    closeModal() {
      const currDate = new Date();
      this.showModal = false;
      this.$store.dispatch('User/updateNotificationAt', currDate);
    },
  },
};
</script>
<style>
.btn-wrapper{
  display: flex;
  align-items: center;
  justify-content: center;
}
#continue_btn{
    padding-right: 30px;
    padding-left: 30px;
}
</style>
